module.exports = {"130881100":"平泉镇","130881101":"黄土梁子镇","130881102":"榆树林子镇","130881103":"杨树岭镇","130881104":"七沟镇","130881105":"小寺沟镇","130881106":"党坝镇","130881107":"卧龙镇","130881108":"南五十家子镇","130881109":"北五十家子镇","130881110":"桲椤树镇","130881111":"柳溪镇","130881112":"平北镇","130881113":"青河镇","130881114":"台头山镇","130881200":"王土房乡","130881203":"七家岱满族乡","130881206":"茅兰沟满族蒙古族乡","130881210":"道虎沟乡"}


//////////////////
// WEBPACK FOOTER
// ./src/town/130881.json
// module id = 299
// module chunks = 0